import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M10 1.667c-4.595 0-8.333 3.738-8.333 8.333 0 4.595 3.739 8.333 8.333 8.333 4.595 0 8.334-3.738 8.334-8.333 0-4.595-3.739-8.333-8.334-8.333zm4.658 6.14L9.332 13.09a.82.82 0 01-1.149.02l-2.82-2.568a.847.847 0 01-.062-1.17.826.826 0 011.17-.041l2.234 2.046 4.762-4.762a.832.832 0 011.19 0 .832.832 0 010 1.19z"
        fill="#27AE60"
      />
    </Svg>
  );
}

export default SvgComponent;
